import type { State } from '../../types';
import { sortBy } from 'lodash';
import { employeesOptions } from './employeesOptions';
import { employeesShortNamesAndMe } from '../employees/employees-short-names-and-me';
import { getContactsAsUsers } from '../partners/get-contacts-as-users';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';

export function employeesAndContactsOptions(
  state: State,
  selectedEmployees: string[] | undefined = undefined,
): SelectDropdownOption[] {
  const contactsOptions = sortBy(
    getContactsAsUsers(state).map((item) => ({
      value: item.uuid,
      text: item.name + ' (' + item.partnerName + ')',
    })),
    ['text'],
  );
  return employeesOptions(employeesShortNamesAndMe(state), selectedEmployees).concat(contactsOptions);
}
